import React from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'

interface PaginationInfo {
  current: number
  total: number
  pages: number
  hasNext: boolean
  hasPrev: boolean
}

interface UserPaginationProps {
  pagination: PaginationInfo
  onPageChange: (page: number) => void
  itemName?: string
}

const UserPagination: React.FC<UserPaginationProps> = ({
  pagination,
  onPageChange,
  itemName = 'items'
}) => {
  if (pagination.pages <= 1) return null

  return (
    <div className="flex items-center justify-between px-6 py-3 border-t border-border">
      <div className="flex items-center text-sm text-muted-foreground">
        <span>
          Page {pagination.current} of {pagination.pages} ({pagination.total} total {itemName})
        </span>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(pagination.current - 1)}
          disabled={!pagination.hasPrev}
          className="p-1 rounded text-muted-foreground hover:text-foreground disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          title="Previous page"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        <button
          onClick={() => onPageChange(pagination.current + 1)}
          disabled={!pagination.hasNext}
          className="p-1 rounded text-muted-foreground hover:text-foreground disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          title="Next page"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}

export default UserPagination 